import axios from "axios";

const StripeService = {
  createSession(data) {
    const url = process.env.VUE_APP_FIREBASE_BACKEND_URL;
    return axios.post(url + "/stripeCheckoutSessionCreate", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};

export default StripeService;
